/* James Aston · The Language of the Leather
   The mark, the whisper, the opening. Works by mouse, keyboard and screen reader.
   The mark is charcoal with a solid gold underline. Hovering or focusing a term raises the whisper: a
   charcoal short box with the term name, the short definition and a "Read on" prompt. ONLY "Read on"
   opens the full definition (a click on the term does not). The full definition grows open in place,
   like the sample; the page glides so it sits in the centre of the screen. It closes only by the x,
   and on closing the page glides back to where the reader was. Reads data from #ja-glossary-data. */
(function () {
  'use strict';
  if (window.__jaGlossaryInit) return;
  window.__jaGlossaryInit = true;

  var DATA = {};
  var dataEl = document.getElementById('ja-glossary-data');
  if (dataEl) {
    try {
      JSON.parse(dataEl.textContent).forEach(function (t) { DATA[t.slug] = t; });
    } catch (e) { /* leave DATA empty; marks fall back to the glossary page */ }
  }

  /* ---------------- The whisper (short box) ---------------- */
  var whisper = null, whisperTerm = null, hideTimer = null, suppressWhisper = false;

  function makeWhisper() {
    if (whisper) return whisper;
    whisper = document.createElement('div');
    whisper.className = 'ja-whisper';
    whisper.id = 'ja-whisper';
    whisper.setAttribute('role', 'tooltip');
    whisper.innerHTML =
      '<span class="ja-whisper__term"></span>' +
      '<span class="ja-whisper__text"></span>' +
      '<span class="ja-whisper__prompt" role="button" tabindex="0">Read on</span>';
    whisper.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    whisper.addEventListener('mouseleave', hideWhisperSoon);
    var prompt = whisper.querySelector('.ja-whisper__prompt');
    prompt.addEventListener('focus', function () { clearTimeout(hideTimer); });
    prompt.addEventListener('blur', hideWhisperSoon);
    prompt.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (whisperTerm) openInline(whisperTerm); });
    prompt.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (whisperTerm) openInline(whisperTerm); } });
    document.body.appendChild(whisper);
    return whisper;
  }

  function position(w, term) {
    w.classList.remove('is-below');
    w.style.left = '0px';
    w.style.top = '0px';
    var r = term.getBoundingClientRect();
    var ww = w.offsetWidth, wh = w.offsetHeight, gap = 12;
    var docW = document.documentElement.clientWidth;
    var left = window.scrollX + r.left + (r.width / 2) - (ww / 2);
    left = Math.max(window.scrollX + 12, Math.min(left, window.scrollX + docW - ww - 12));
    var top = window.scrollY + r.top - wh - gap;
    if (r.top - wh - gap < 8) { top = window.scrollY + r.bottom + gap; w.classList.add('is-below'); }
    w.style.left = left + 'px';
    w.style.top = top + 'px';
    var arrow = (window.scrollX + r.left + Math.min(r.width, 90) / 2) - left;
    w.style.setProperty('--ja-arrow', Math.max(18, Math.min(ww - 18, arrow)) + 'px');
  }

  function showWhisper(term) {
    if (suppressWhisper) return;
    var d = DATA[term.getAttribute('data-term')];
    if (!d) return;
    var w = makeWhisper();
    w.querySelector('.ja-whisper__term').textContent = d.term;
    w.querySelector('.ja-whisper__text').textContent = d.whisper;
    whisperTerm = term;
    term.setAttribute('aria-describedby', 'ja-whisper');
    position(w, term);
    w.classList.add('is-visible');
  }

  function hideWhisper() {
    if (whisper) whisper.classList.remove('is-visible');
    if (whisperTerm) whisperTerm.removeAttribute('aria-describedby');
    whisperTerm = null;
  }
  function hideWhisperSoon() { clearTimeout(hideTimer); hideTimer = setTimeout(hideWhisper, 260); }

  /* ---------------- The opening (inline unfold; centre on open, go back on close by the x) ---------------- */
  var currentUnfold = null, savedScroll = 0;

  function removeBox(el) {
    el.style.maxHeight = '0px';
    window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 480);
  }

  function closeUnfold() {
    if (!currentUnfold) return;
    var el = currentUnfold, term = el.__jaTerm;
    currentUnfold = null;
    removeBox(el);
    suppressWhisper = true;
    hideWhisper();
    /* the page glides back to where the reader was when they opened it */
    window.scrollTo({ top: savedScroll, behavior: 'smooth' });
    if (term && term.focus) term.focus({ preventScroll: true });
    window.setTimeout(function () { suppressWhisper = false; }, 800);
  }

  function openInline(term) {
    var slug = term.getAttribute('data-term');
    var d = DATA[slug];
    if (!d) { window.location.href = '/pages/language-of-the-leather#' + slug; return; }
    if (currentUnfold && currentUnfold.getAttribute('data-for') === slug) {
      centre(currentUnfold);
      return;
    }
    savedScroll = window.scrollY;
    if (currentUnfold) { removeBox(currentUnfold); currentUnfold = null; }
    var host = term.closest('p') || term.parentElement;
    var box = document.createElement('div');
    box.className = 'ja-unfold';
    box.setAttribute('data-for', slug);
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', d.term);
    box.innerHTML =
      '<div class="ja-unfold__inner">' +
      '<button type="button" class="ja-unfold__close" aria-label="Close">&#215;</button>' +
      '<div class="ja-unfold__term" tabindex="-1">' + d.term + '</div>' +
      '<div class="ja-unfold__body">' + d.entry + '</div>' +
      '</div>';
    box.__jaTerm = term;
    host.parentNode.insertBefore(box, host.nextSibling);
    box.querySelector('.ja-unfold__close').addEventListener('click', closeUnfold);
    void box.offsetHeight;
    box.style.maxHeight = box.scrollHeight + 'px';
    currentUnfold = box;
    hideWhisper();
    centre(box);
    box.querySelector('.ja-unfold__term').focus({ preventScroll: true });
  }

  function centre(box) {
    var finalH = box.scrollHeight;
    var topAbs = box.getBoundingClientRect().top + window.scrollY;
    var target = topAbs + (finalH / 2) - (window.innerHeight / 2);
    window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
  }

  /* ---------------- Bind the marks ---------------- */
  var noHover = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var marks = document.querySelectorAll('.ja-term[data-term]');
  Array.prototype.forEach.call(marks, function (term) {
    term.setAttribute('tabindex', '0');
    term.setAttribute('role', 'button');
    var d = DATA[term.getAttribute('data-term')];
    if (d) term.setAttribute('aria-label', d.term + '. Read on for the full entry.');
    if (noHover) {
      /* touch: a tap toggles the short box; it stays until the reader taps away or taps Read on */
      term.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (whisperTerm === term && whisper && whisper.classList.contains('is-visible')) { hideWhisper(); }
        else { clearTimeout(hideTimer); showWhisper(term); }
      });
    } else {
      term.addEventListener('mouseenter', function () { clearTimeout(hideTimer); showWhisper(term); });
      term.addEventListener('mouseleave', hideWhisperSoon);
      term.addEventListener('focus', function () { showWhisper(term); });
      term.addEventListener('blur', hideWhisperSoon);
      /* a click on the term shows the short box only; it does NOT open the full definition */
      term.addEventListener('click', function (e) { e.preventDefault(); showWhisper(term); });
    }
    /* keyboard: Enter on the term raises the whisper and moves to its "Read on" so it can be opened */
    term.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        showWhisper(term);
        clearTimeout(hideTimer);
        var p = whisper && whisper.querySelector('.ja-whisper__prompt');
        if (p) p.focus();
      }
    });
  });

  window.addEventListener('scroll', function () {
    if (whisper && whisper.classList.contains('is-visible')) hideWhisper();
  }, { passive: true });
  window.addEventListener('resize', function () {
    if (currentUnfold) currentUnfold.style.maxHeight = currentUnfold.scrollHeight + 'px';
  });
  if (noHover) {
    document.addEventListener('click', function (e) {
      if (whisperTerm && !e.target.closest('.ja-term') && !e.target.closest('.ja-whisper')) hideWhisper();
    });
  }

  /* ---------------- Glossary page: deep-link, highlight, return, ascend ---------------- */
  var glossary = document.getElementById('ja-glossary-page');
  if (glossary) {
    var prevScroll = null;

    var toTop = glossary.querySelector('.ja-gl__totop');
    if (toTop) {
      toTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        var h = glossary.querySelector('.ja-gl__h1');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      });
      var toggleTop = function () {
        if (window.scrollY > window.innerHeight * 0.6) toTop.classList.add('is-shown');
        else toTop.classList.remove('is-shown');
      };
      window.addEventListener('scroll', toggleTop, { passive: true });
      toggleTop();
    }

    function activate(slug) {
      var entry = document.getElementById(slug);
      if (!entry || !entry.classList.contains('ja-gl__entry')) return;
      var actives = glossary.querySelectorAll('.ja-gl__entry.is-active');
      Array.prototype.forEach.call(actives, function (x) {
        x.classList.remove('is-active');
        var ob = x.querySelector('.ja-gl__back'); if (ob) ob.hidden = true;
      });
      entry.classList.add('is-active');
      entry.scrollIntoView({ behavior: 'smooth', block: 'start' });
      entry.focus({ preventScroll: true });
      var back = entry.querySelector('.ja-gl__back'); if (back) back.hidden = false;
    }

    Array.prototype.forEach.call(glossary.querySelectorAll('[data-ja-index]'), function (a) {
      a.addEventListener('click', function () { prevScroll = window.scrollY; });
    });
    Array.prototype.forEach.call(glossary.querySelectorAll('.ja-gl__back'), function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (prevScroll !== null) { window.scrollTo(0, prevScroll); prevScroll = null; }
        else if (document.referrer && document.referrer.indexOf(location.origin) === 0) { history.back(); }
        else { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      });
    });
    if (location.hash && location.hash.length > 1) {
      setTimeout(function () { activate(location.hash.slice(1)); }, 90);
    }
    window.addEventListener('hashchange', function () {
      if (location.hash && location.hash.length > 1) { prevScroll = prevScroll === null ? 0 : prevScroll; activate(location.hash.slice(1)); }
    });
  }
})();